import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import urldata from "../../../../urldata";
import Imageurldata from "../../../../Imageurldata";
//import DatePicker from 'react-date-picker';
import Button from "../../../../component/Button/Button";
import { Col, Row, Modal } from "react-bootstrap";
import InputText from "../../../../component/InputText/InputText";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import upload from "../../../../images/careers/upload.svg";
import Toast from "../../../../component/Toast/Toast";
import close from "../../../../images/close.svg";
import check from "../../../../images/check.svg";

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import config from "../../../../config/config";
import BlogOrdering from "./BlogOrdering ";

const expinyearsOptions = [
  {
    name: "",
  },
  {
    name: "Months",
  },
  {
    name: "Years",
  },
];

const HomepageBannerList = (props) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);
  const [exptabshow, setExptabshow] = useState(false);
  const [textline1, settextline1] = useState("");
  const [textline1err, settextline1err] = useState("");
  const [date2, setdate2] = useState(new Date());
  const [link, setlink] = useState("");
  const [linkerr, setlinkErr] = useState("");
  const [slug, setslug] = useState("");
  const [bannerimg, setbannerimg] = useState("");
  const [bannerimg2, setbannerimg2] = useState("");
  const [date, setdate] = useState("");
  const [title, settitle] = useState("");
  const [synopsis, setsynopsis] = useState("");
  const [description, setdescription] = useState("");
  // const [ingredients, setingredients] = useState("");
  const [bannerimgerr, setbannerimgErr] = useState("");
  const [bannerimgnotpresent, setbannerimgnotpresent] = useState("");

  const [bannerimgerr2, setbannerimgErr2] = useState("");
  const [bannerimgnotpresent2, setbannerimgnotpresent2] = useState("");

  const [mbbannerimg, setmbbannerimg] = useState("");
  const [mbbannerimgerr, setmbbannerimgErr] = useState("");
  const [mbImgNotPresent, setmbImgNotPresent] = useState("");
  const [type, settype] = useState("Add");
  const [mbbannerimg2, setmbbannerimg2] = useState("");
  const [isupdate, setisupdate] = useState(false);
  const [mbbannerimgerr2, setmbbannerimgErr2] = useState("");
  const [mbImgNotPresent2, setmbImgNotPresent2] = useState("");
  const [dateval, setdateval] = useState(new Date());
  const [updateModel, setUpdateModel] = useState(false);
  const [showMobImg, setShowMobImg] = useState("");
  const [showDesktopImg, setShowDesktopImg] = useState("");
  const [showMobImg2, setShowMobImg2] = useState("");
  const [showDesktopImg2, setShowDesktopImg2] = useState("");

  const [titleErr, setTitleErr] = useState("");
  const [synopsisErr, setSynopsisErr] = useState("");
  const [descErr, setdescErr] = useState("");
  // const [ingreErr, setIngreErr] = useState("");

  const [bannerid, setbannerid] = useState("");

  const [toastlist, setToastList] = useState([]);

  const [reorderModalOpen, setReorderModalOpen] = useState(false);

  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"], // toggled buttons
      ["blockquote", "code-block"],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: "ordered" }, { list: "bullet" }],
      [{ script: "sub" }, { script: "super" }], // superscript/subscript
      [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
      [{ direction: "rtl" }], // text direction

      [{ size: ["small", false, "large", "huge"] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],

      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
    // toolbar: [
    //   [{ header: [1, 2, false] }],
    //   ["bold", "italic", "underline"],
    //   [{ align: [] }],
    // ],
  };
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
  ];
  let toastProperties = null;

  const showToast = (type) => {
    const id = Math.floor(Math.random() * 101 + 1);
    switch (type) {
      case "success":
        toastProperties = {
          id,
          title: "Success",
          description: `Blog ${updateModel ? "updated" : "added"} Successfully`,
          backgroundColor: "#329F33",
          icon: check,
        };
        break;
      case "danger":
        toastProperties = {
          id,
          title: "Something Went Wrong",
          description: "",
          backgroundColor: "red",
          icon: close,
        };
        break;
      case "delete":
        toastProperties = {
          id,
          title: "Success",
          description: "Blog deleted Successfully",
          backgroundColor: "#329F33",
          icon: check,
        };
        break;

      default:
        setToastList([]);
    }

    setToastList([...toastlist, toastProperties]);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setisupdate(false);
    setUpdateModel(false);
    setShow(true);
    settype("Add");
    setShowMobImg(false);
    setShowDesktopImg(false);
    setShowMobImg2(false);
    setShowDesktopImg2(false);
    settextline1("");
    setdate("");
    settitle("");
    setsynopsis("");
    setdescription("");
    // setingredients("");
    setdate2(new Date());
    setlink("");
    setbannerimg("");
    setmbbannerimg("");
    setbannerimg2("");
    setmbbannerimg2("");
  };

  useEffect(() => {
    setLoading(true);
    //${config.api_url}blogs
    let url = new URL(urldata + "admin/getBannerImages");
    axios({
      method: "get",
      url: `${config.api_url}blogs`,
      //withCredentials: true,
    })
      .then((response) => {
        // console.log(response);
        // const templist = response.data.reverse();
        const templist = response.data.sort((a, b) => a.position - b.position);
        templist.forEach((item) => {
          // console.log(item)
          let deslen = item.description.length;
          // let inlen = item.ingredients.length;
          let synlen = item.synopsis.length;
          if (synlen <= 15) {
            item.showsynopsis = item.synopsis;
          } else {
            item.showsynopsis = item.synopsis.substring(0, 15);
            item.showsynopsis += "...";
          }
          if (deslen <= 15) {
            item.showdescription = item.description.substring(3, deslen - 4);
          } else {
            item.showdescription = item.description.substring(3, 15);
            item.showdescription += "...";
          }
          // if (inlen <= 15) {
          //   item.showingredients = item.ingredients.substring(3, inlen - 4);
          // } else {
          //   item.showingredients = item.ingredients.substring(8, 20);
          //   item.showingredients += "...";
          // }
        });
        setList(templist);
        console.log(list);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        //showToast("danger");
      });
  }, []);

  const handleShowForUpdate = (rowData) => {
    setisupdate(true);
    settype("Update");
    console.log(rowData);
    setUpdateModel(true);
    setShow(true);
    setdate(rowData.date);
    settitle(rowData.title);
    setdate2(new Date(rowData.date2));
    setsynopsis(rowData.synopsis);
    setdescription(rowData.description);
    // setingredients(rowData.ingredients);
    setslug(rowData.slug);
    setmbbannerimg(Imageurldata + rowData.mobileImageUrl.replaceAll("\\", "/"));
    setbannerimg(Imageurldata + rowData.desktopImageUrl.replaceAll("\\", "/"));
    setmbbannerimg2(
      Imageurldata + rowData.mobileImageUrl2.replaceAll("\\", "/")
    );
    setbannerimg2(
      Imageurldata + rowData.desktopImageUrl2.replaceAll("\\", "/")
    );
    setmbImgNotPresent(
      rowData.mobileImageUrl.replaceAll("\\", "/") ? false : true
    );
    setbannerimgnotpresent(
      rowData.desktopImageUrl.replaceAll("\\", "/") ? false : true
    );
    setmbImgNotPresent2(
      rowData.mobileImageUrl2.replaceAll("\\", "/") ? false : true
    );
    setbannerimgnotpresent2(
      rowData.desktopImageUrl2.replaceAll("\\", "/") ? false : true
    );

    setbannerid(rowData._id);

    setShowMobImg(false);
    setShowDesktopImg(false);
    setShowMobImg2(false);
    setShowDesktopImg2(false);

    setTitleErr("");
    setSynopsisErr("");
    setdescErr("");
    // setIngreErr("");

    setbannerimgErr("");
    setmbbannerimgErr("");
    setbannerimgErr2("");
    setmbbannerimgErr2("");
  };

  const updateBanner = () => {
    var formData = new FormData();
    formData.append("date", date);
    formData.append("slug", slug);
    formData.append("title", title);
    formData.append("synopsis", synopsis);
    formData.append("description", description);
    // formData.append("ingredients", ingredients);
    formData.append("date2", date2);
    if (mbImgNotPresent) {
      formData.append("mobileImageUrl", mbbannerimg);
      setmbImgNotPresent(false);
    }

    if (bannerimgnotpresent) {
      formData.append("desktopImageUrl", bannerimg);
      setbannerimgnotpresent(false);
    }
    if (mbImgNotPresent2) {
      formData.append("mobileImageUrl2", mbbannerimg2);
      setmbImgNotPresent2(false);
    }

    if (bannerimgnotpresent2) {
      formData.append("desktopImageUrl2", bannerimg2);
      setbannerimgnotpresent2(false);
    }
    console.log(mbImgNotPresent);
    console.log(mbImgNotPresent2);
    console.log(bannerimgnotpresent);
    console.log(bannerimgnotpresent2);
    let url = new URL(urldata + "admin/updateBannerImages");
    formData.append("id", bannerid);
    //url.searchParams.append('id', bannerid)
    var decoded = decodeURIComponent(url);

    axios({
      method: "post",
      url: `${config.api_url}blogs/update`,
      data: formData,
      //withCredentials: true,/banner/udpate
    })
      .then((response) => {
        const templist = response.data.sort((a, b) => a.position - b.position);
        templist.forEach((item) => {
          let deslen = item.description.length;
          // let inlen = item.ingredients.length;
          let synlen = item.synopsis.length;
          if (synlen <= 15) {
            item.showsynopsis = item.synopsis;
          } else {
            item.showsynopsis = item.synopsis.substring(0, 15);
            item.showsynopsis += "...";
          }
          if (deslen <= 15) {
            item.showdescription = item.description.substring(3, deslen - 4);
          } else {
            item.showdescription = item.description.substring(3, 15);
            item.showdescription += "...";
          }
          // if (inlen <= 15) {
          //   item.showingredients = item.ingredients.substring(3, inlen - 4);
          // } else {
          //   item.showingredients = item.ingredients.substring(8, 20);
          //   item.showingredients += "...";
          // }
        });
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        console.log("error--", error);
        setShow(false);
        // showToast("danger");
      });
  };
  const handleCheck = (rowData) => {
    // console.log(rowData)dvf
    // console.log(rowData.checked)
    var formData = new FormData();
    formData.append("id", rowData._id);
    formData.append("checked", !rowData.checked);
    console.log(rowData._id);
    console.log(!rowData.checked);
    rowData.checked = !rowData.checked;
    axios({
      method: "post",
      url: `${config.api_url}blogs/update`,
      data: formData,
      //withCredentials: true,/banner/udpate
    }).then((response) => {
      // const templist = response.data.reverse();
      const templist = response.data.sort((a, b) => a.position - b.position);
      templist.forEach((item) => {
        // let inlen = item.ingredients.length;
        let synlen = item.synopsis.length;
        if (synlen <= 15) {
          item.showsynopsis = item.synopsis;
        } else {
          item.showsynopsis = item.synopsis.substring(0, 15);
          item.showsynopsis += "...";
        }
        let deslen = item.description.length;
        if (deslen <= 15) {
          item.showdescription = item.description.substring(3, deslen - 4);
        } else {
          item.showdescription = item.description.substring(3, 15);
          item.showdescription += "...";
        }
        // if (inlen <= 15) {
        //   item.showingredients = item.ingredients.substring(3, inlen - 4);
        // } else {
        //   item.showingredients = item.ingredients.substring(8, 20);
        //   item.showingredients += "...";
        // }
      });
      setList(templist);
      showToast("success");
      setShow(false);
    });
    //console.log(!checked)
    // setChecked(!checked)
    // console.log(checked)
  };
  const createbanner = () => {
    var formData = new FormData();
    formData.append("date", date);
    formData.append("date2", date2);
    formData.append("title", title);
    formData.append("synopsis", synopsis);
    formData.append("description", description);
    // formData.append("ingredients", ingredients);
    formData.append("mobileImageUrl", mbbannerimg);
    formData.append("desktopImageUrl", bannerimg);
    formData.append("mobileImageUrl2", mbbannerimg2);
    formData.append("desktopImageUrl2", bannerimg2);

    let url = new URL(urldata + "admin/addBannerImages");

    axios({
      method: "post",
      url: `${config.api_url}blogs/new`,
      data: formData,
      // withCredentials: true, https://laxmihos.com/api
    })
      .then((response) => {
        console.log(response);
        // const templist = response.data.reverse();
        const templist = response.data.sort((a, b) => a.position - b.position);
        templist.forEach((item) => {
          let deslen = item.description.length;
          // let inlen = item.ingredients.length;
          let synlen = item.synopsis.length;
          if (synlen <= 15) {
            item.showsynopsis = item.synopsis;
          } else {
            item.showsynopsis = item.synopsis.substring(0, 15);
            item.showsynopsis += "...";
          }
          if (deslen <= 15) {
            item.showdescription = item.description.substring(3, deslen - 4);
          } else {
            item.showdescription = item.description.substring(3, 15);
            item.showdescription += "...";
          }
          // if (inlen <= 15) {
          //   item.showingredients = item.ingredients.substring(3, inlen - 4);
          // } else {
          //   item.showingredients = item.ingredients.substring(8, 20);
          //   item.showingredients += "...";
          // }
        });
        setList(templist);
        showToast("success");
        setShow(false);
      })
      .catch((error) => {
        // showToast("danger");
      });
  };

  const submit = () => {
    //console.log(dateval)
    var formIsValid = true;
    if (!title) {
      formIsValid = false;
      setTitleErr("*Please fill blog title.");
    } else {
      setTitleErr("");
    }
    if (!synopsis) {
      formIsValid = false;
      setSynopsisErr("*Please fill blog synopsis.");
    } else {
      setSynopsisErr("");
    }
    if (!description) {
      formIsValid = false;
      setdescErr("*Please fill blog description.");
    } else {
      setdescErr("");
    }
    // if (!ingredients) {
    //   formIsValid = false;
    //   setIngreErr("*Please fill ingredients details.");
    // } else {
    //   setIngreErr("");
    // }

    if (!bannerimg) {
      formIsValid = false;
      setbannerimgErr("*Please upload desktop banner image.");
    } else {
      setbannerimgErr("");
    }

    if (!mbbannerimg) {
      formIsValid = false;
      setmbbannerimgErr("*Please upload mobile  banner image.");
    } else {
      setmbbannerimgErr("");
    }
    if (!bannerimg2) {
      formIsValid = false;
      setbannerimgErr2("*Please upload desktop banner image.");
    } else {
      setbannerimgErr2("");
    }

    if (!mbbannerimg2) {
      formIsValid = false;
      setmbbannerimgErr2("*Please upload mobile  banner image.");
    } else {
      setmbbannerimgErr2("");
    }

    if (formIsValid) {
      if (updateModel) {
        updateBanner();
      } else {
        createbanner();
      }
    }
  };

  const deleteBtnClick = (id) => {
    setLoading(true);
    let data = {};
    data.id = id;

    let url = new URL(urldata + "admin/deleteBannerImage");

    axios({
      method: "post",
      url: `${config.api_url}blogs/delete`,
      data: data,
      // withCredentials: true,
    })
      .then((response) => {
        //   showToast("success");
        //   props.onHide(); props.history.push('/admin/login')
        //Eshaans update
        // const templist = response.data.reverse();
        const templist = response.data.sort((a, b) => a.position - b.position);
        templist.forEach((item) => {
          let deslen = item.description.length;
          // let inlen = item.ingredients.length;
          let synlen = item.synopsis.length;
          if (synlen <= 15) {
            item.showsynopsis = item.synopsis;
          } else {
            item.showsynopsis = item.synopsis.substring(0, 15);
            item.showsynopsis += "...";
          }
          if (deslen <= 15) {
            item.showdescription = item.description.substring(3, deslen - 4);
          } else {
            item.showdescription = item.description.substring(3, 15);
            item.showdescription += "...";
          }
          // if (inlen <= 15) {
          //   item.showingredients = item.ingredients.substring(3, inlen - 4);
          // } else {
          //   item.showingredients = item.ingredients.substring(8, 20);
          //   item.showingredients += "...";
          // }
        });
        //serfrefref
        setList(templist);
        setLoading(false);
        showToast("delete");
      })
      .catch((error) => {
        // showToast("danger");
        setLoading(false);
      });
  };

  if (loading) {
    return (
      <div id="wrapper">
        <div className="profile-main-loader">
          <div className="loader">
            <svg className="circular-loader" viewBox="25 25 50 50">
              <circle
                className="loader-path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke="#ed1c24"
                stroke-width="2"
              />
            </svg>
          </div>
        </div>
      </div>
    );
  }
  return (
    <>
      <div className="addjobinlist text-right mb-4">
        <Button title="Add Blog" onClick={handleShow} />
        <Button
          title="View Ordering"
          onClick={() => setReorderModalOpen(true)}
        />
      </div>
      <MaterialTable
        title="Blog List"
        columns={[
          {
            title: "Mark featured blog",
            render: (rowData) => (
              <div className="d-f">
                <label>
                  <input
                    type="checkbox"
                    defaultChecked={rowData.checked}
                    onChange={() => handleCheck(rowData)}
                  />
                </label>
              </div>
            ),
          },
          { title: "Date", field: "showDate" },

          { title: "Title", field: "title" },
          { title: "Synopsis", field: "showsynopsis" },
          { title: "Description", field: "showdescription" },
          // { title: "Ingredients", field: "showingredients" },

          {
            field: "url",

            title: "Mobile Image  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title="View"
                  onClick={() => {
                    window.open(
                      Imageurldata +
                        rowData.mobileImageUrl.replaceAll("\\", "/"),
                      "_blank"
                    );
                  }}
                ></Button>
              </div>
            ),
          },
          {
            field: "url",

            title: "Desktop Image  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title="View"
                  onClick={() => {
                    window.open(
                      Imageurldata +
                        rowData.desktopImageUrl.replaceAll("\\", "/"),
                      "_blank"
                    );
                  }}
                ></Button>
              </div>
            ),
          },
          {
            field: "url",

            title: "Inner Mobile image",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title="View"
                  onClick={() => {
                    window.open(
                      Imageurldata +
                        rowData.mobileImageUrl2.replaceAll("\\", "/"),
                      "_blank"
                    );
                  }}
                ></Button>
              </div>
            ),
          },
          {
            field: "url",

            title: "Inner Desktop image",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title="View"
                  onClick={() => {
                    window.open(
                      Imageurldata +
                        rowData.desktopImageUrl2.replaceAll("\\", "/"),
                      "_blank"
                    );
                  }}
                ></Button>
              </div>
            ),
          },
          {
            field: "url",

            title: "Action  ",
            render: (rowData) => (
              <div className="d-f">
                <Button
                  title=" Update"
                  onClick={() => {
                    handleShowForUpdate(rowData);
                  }}
                ></Button>
                <Button
                  title=" Delete"
                  onClick={() => deleteBtnClick(rowData._id)}
                ></Button>
              </div>
            ),
          },
        ]}
        data={list}
        options={{
          exportButton: true,
          actionsColumnIndex: -1,
        }}
      />

      <Modal
        {...props}
        //   size="lg"
        //   aria-labelledby="contained-modal-title-vcenter"
        dialogClassName="addbannerModel"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className="model">
          <div className="title">{type} blog</div>
          {isupdate && (
            <Row>
              {/* <Col lg={3} className="column">
              <div className="titleitem">Add date</div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={date}
                onChange={(e) => setdate(e.target.value)}
                // maxlength="31"
                type="text"
              />
            </Col> */}
              <Col lg={3} className="column">
                <div className="titleitem">{type} date </div>
              </Col>
              <Col lg={9} className="column">
                <DatePicker
                  selected={date2}
                  onChange={(date) => setdate2(date)}
                />

                {/* <div className="count">{textline1.length}/31</div>   <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />*/}
              </Col>
              {/* <Col lg={3} className="column">
              <div className="titleitem">Add date</div>
            </Col>
            <Col lg={9} className="column">
            <DatePicker
              onChange={setdateval}
              value={dateval}
            />
            </Col> */}
              {/* <div className="count">{textline1.length}/31</div> */}

              <Col lg={3} className="column">
                <div className="titleitem">{type} title</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  value={title}
                  onChange={(e) => settitle(e.target.value)}
                  // maxlength="31"
                  type="text"
                />
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">{type} slug</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  value={slug}
                  onChange={(e) => setslug(e.target.value)}
                  // maxlength="31"
                  type="text"
                />
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">{type} synopsis</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  value={synopsis}
                  onChange={(e) => setsynopsis(e.target.value)}
                  // maxlength="31"
                  type="text"
                />

                {/* <div className="count">{textline1.length}/31</div> */}
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">{type} description</div>
              </Col>
              <Col lg={9} className="column">
                <ReactQuill
                  formats={formats}
                  value={description}
                  modules={modules}
                  onChange={(e) => {
                    setdescription(e);
                  }}
                />
              </Col>
              {/* <Col lg={3} className="column">
                <div className="titleitem">{type} ingredients</div>
              </Col>
              <Col lg={9} className="column">
                <ReactQuill
                  formats={formats}
                  value={ingredients}
                  modules={modules}
                  onChange={(e) => {
                    setingredients(e);
                  }}
                />
              </Col> */}

              <Col lg={3} className="column">
                <div className="titleitem">{type} Desktop Image</div>
                <div className="desc">Size :- 431 × 387 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG"
                  type="file"
                  onChange={(e) => {
                    setbannerimg(e.target.files[0]);
                    setShowDesktopImg(true);
                    setbannerimgnotpresent(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{bannerimgerr} </div>

                <div>
                  {bannerimg !== "" && (
                    <img
                      src={
                        showDesktopImg
                          ? URL.createObjectURL(bannerimg)
                          : bannerimg
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">{type} Mobile Image</div>
                <div className="desc">Size :- 344 × 260 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage1"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG "
                  type="file"
                  onChange={(e) => {
                    setmbbannerimg(e.target.files[0]);
                    setShowMobImg(true);
                    setmbImgNotPresent(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage1" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{mbbannerimgerr} </div>

                <div>
                  {mbbannerimg !== "" && (
                    <img
                      src={
                        showMobImg
                          ? URL.createObjectURL(mbbannerimg)
                          : mbbannerimg
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>
              <Col lg={3} className="column">
                <div className="titleitem">{type} Inner Desktop Image</div>
                <div className="desc">Size :- 1363 × 852 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage2"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG"
                  type="file"
                  onChange={(e) => {
                    setbannerimg2(e.target.files[0]);
                    setShowDesktopImg2(true);
                    setbannerimgnotpresent2(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage2" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{bannerimgerr2} </div>

                <div>
                  {bannerimg2 !== "" && (
                    <img
                      src={
                        showDesktopImg2
                          ? URL.createObjectURL(bannerimg2)
                          : bannerimg2
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">{type} Inner Mobile Image</div>
                <div className="desc">Size :- 345 × 328 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage3"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG "
                  type="file"
                  onChange={(e) => {
                    setmbbannerimg2(e.target.files[0]);
                    setShowMobImg2(true);
                    setmbImgNotPresent2(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage3" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{mbbannerimgerr2} </div>

                <div>
                  {mbbannerimg2 !== "" && (
                    <img
                      src={
                        showMobImg2
                          ? URL.createObjectURL(mbbannerimg2)
                          : mbbannerimg2
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>
            </Row>
          )}
          {!isupdate && (
            <Row>
              {/* <Col lg={3} className="column">
              <div className="titleitem">Add date</div>
            </Col>
            <Col lg={9} className="column">
              <input
                value={date}
                onChange={(e) => setdate(e.target.value)}
                // maxlength="31"
                type="text"
              />
            </Col> */}
              {/* <div className="count">{textline1.length}/31</div> */}

              <Col lg={3} className="column">
                <div className="titleitem">Add date </div>
              </Col>
              <Col lg={9} className="column">
                <DatePicker
                  selected={date2}
                  onChange={(date) => setdate2(date)}
                />

                {/* <div className="count">{textline1.length}/31</div>   <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />*/}
              </Col>
              <Col lg={3} className="column">
                <div className="titleitem">Add title</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  value={title}
                  onChange={(e) => settitle(e.target.value)}
                  // maxlength="31"
                  type="text"
                />
                <div className="err">{titleErr}</div>
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">Add synopsis</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  value={synopsis}
                  onChange={(e) => setsynopsis(e.target.value)}
                  // maxlength="31"
                  type="text"
                />
                <div className="err">{synopsisErr}</div>

                {/* <div className="count">{textline1.length}/31</div> */}
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">Add description</div>
              </Col>
              <Col lg={9} className="column">
                <ReactQuill
                  formats={formats}
                  value={description}
                  modules={modules}
                  onChange={(e) => {
                    setdescription(e);
                  }}
                />
                <div className="err">{descErr}</div>
              </Col>
              {/* <Col lg={3} className="column">
                <div className="titleitem">Add ingredients</div>
              </Col>
              <Col lg={9} className="column">
                <ReactQuill
                  formats={formats}
                  value={ingredients}
                  modules={modules}
                  onChange={(e) => {
                    setingredients(e);
                  }}
                />
                <div className="err">{ingreErr}</div>
              </Col> */}

              <Col lg={3} className="column">
                <div className="titleitem">Add Desktop Image</div>
                <div className="desc">Size :- 431 × 387 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG"
                  type="file"
                  onChange={(e) => {
                    setbannerimg(e.target.files[0]);
                    setShowDesktopImg(true);
                    setbannerimgnotpresent(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{bannerimgerr} </div>

                <div>
                  {bannerimg !== "" && (
                    <img
                      src={
                        showDesktopImg
                          ? URL.createObjectURL(bannerimg)
                          : bannerimg
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">Add Mobile Image</div>
                <div className="desc">Size :- 344 × 260 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage1"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG "
                  type="file"
                  onChange={(e) => {
                    setmbbannerimg(e.target.files[0]);
                    setShowMobImg(true);
                    setmbImgNotPresent(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage1" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{mbbannerimgerr} </div>

                <div>
                  {mbbannerimg !== "" && (
                    <img
                      src={
                        showMobImg
                          ? URL.createObjectURL(mbbannerimg)
                          : mbbannerimg
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>
              <Col lg={3} className="column">
                <div className="titleitem">Add Inner Desktop Image</div>
                <div className="desc">Size :- 1363 × 852 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage2"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG"
                  type="file"
                  onChange={(e) => {
                    setbannerimg2(e.target.files[0]);
                    setShowDesktopImg2(true);
                    setbannerimgnotpresent2(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage2" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{bannerimgerr2} </div>

                <div>
                  {bannerimg2 !== "" && (
                    <img
                      src={
                        showDesktopImg2
                          ? URL.createObjectURL(bannerimg2)
                          : bannerimg2
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>

              <Col lg={3} className="column">
                <div className="titleitem">Add Inner Mobile Image</div>
                <div className="desc">Size :- 345 × 328 px</div>
              </Col>
              <Col lg={9} className="column">
                <input
                  id="bannerImage3"
                  accept="image/jpg ,image/png, image/JPG ,image/PNG, image/jpeg, image/JPEG "
                  type="file"
                  onChange={(e) => {
                    setmbbannerimg2(e.target.files[0]);
                    setShowMobImg2(true);
                    setmbImgNotPresent2(true);
                  }}
                  name="passport_proof_upload"
                />

                <label for="bannerImage3" className="d-f" id="file-drag">
                  <img src={upload} class="img-fluid" />
                  <div class="chooseTxt">Choose File</div>
                </label>

                <div className="d-f jc-sb">
                  <div className="fileTxt">File Format : JPG / PNG</div>
                </div>
                <div className="err">{mbbannerimgerr2} </div>

                <div>
                  {mbbannerimg2 !== "" && (
                    <img
                      src={
                        showMobImg2
                          ? URL.createObjectURL(mbbannerimg2)
                          : mbbannerimg2
                      }
                      className="img-fluid"
                      style={{ width: "100px", height: "100px" }}
                    />
                  )}
                </div>
              </Col>
            </Row>
          )}
          <div className="btnContainer mt-4">
            <Button onClick={submit} title="SUBMIT" />
          </div>
        </Modal.Body>
      </Modal>
      <BlogOrdering
        isOpen={reorderModalOpen}
        onClose={() => setReorderModalOpen(false)}
        blogs={list}
        onOrderUpdated={(newOrder) => setList(newOrder)}
      />

      <Toast toastList={toastlist} position="top-right" />
    </>
  );
};

export default HomepageBannerList;

// updateBannerImages
